/**
 * BESTIX v5.0 — Main App Component
 * Routes and layout for the application
 */

import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/auth';

// Pages
import HomePage from './pages/HomePage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import HelpPage from './pages/HelpPage';
import SellPage from './pages/SellPage';
import GuaranteePage from './pages/GuaranteePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';
import RefundsPage from './pages/RefundsPage';
import AccessibilityPage from './pages/AccessibilityPage';
import CareersPage from './pages/CareersPage';
import PressPage from './pages/PressPage';
import BlogPage from './pages/BlogPage';
import AccountPage from './pages/AccountPage';
import SignInPage from './pages/SignInPage';
import DoNotSellPage from './pages/DoNotSellPage';
import NotFoundPage from './pages/NotFoundPage';
import MagazinePage from './pages/MagazinePage';
import ArticlePage from './pages/ArticlePage';

export default function App() {
  return (
    <Routes>
      {/* HomePage has its own layout with transparent header */}
      <Route path="/" element={<HomePage />} />
      
      {/* Magazine pages have their own layout */}
      <Route path="/magazine" element={<MagazinePage />} />
      <Route path="/magazine/:slug" element={<ArticlePage />} />
      <Route path="/magazine/category/:category" element={<MagazinePage />} />
      
      {/* Other pages use standard Layout */}
      <Route element={<Layout />}>
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetailPage />} />
        <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
        <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccessPage /></ProtectedRoute>} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/sell" element={<SellPage />} />
        <Route path="/guarantee" element={<GuaranteePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/refunds" element={<RefundsPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/press" element={<PressPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/do-not-sell" element={<DoNotSellPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
